
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import type { GetStaticProps } from 'next';
import useTranslation from 'next-translate/useTranslation';
import StaticPageTemplate from '@/components/StaticTemplate';
import Image from 'next/image';
import { Download } from '@/components/Download';
import type { AccountManager as AccountManagerType } from '@/lib/types/bevmaq.types';
import { useRouter } from 'next/router';
import { AccountManager } from '@/components/AccountManager';
import Trans from 'next-translate/Trans';
import { useEffect, useMemo, useState } from 'react';
import { isEmpty } from 'lodash';
interface PressReleaseItem {
  date: string;
  title: string;
  subtitle: string;
  images: string[];
  pressReleaseDoc: string;
  downloads: {
    title: string;
    url: string;
  }[];
}

function PressReleases() {
  const { t } = useTranslation();
  const pressReleasesDB: PressReleaseItem[] = useMemo(
    () => [
      {
        date: '25/01/2024',
        title: t('common:page_press.release.6.title'),
        subtitle: t('common:page_press.release.6.description'),
        pressReleaseDoc: t('common:page_press.release.6.pressReleaseDoc'),
        images: [t('common:page_press.release.6.cover_pic')],
        downloads: [
          {
            title: 'Download Dossier',
            url: t('common:page_press.release.6.zip'),
          },
        ],
      },
      {
        date: '05/10/2023',
        title: t('common:page_press.release.5.title'),
        subtitle: t('common:page_press.release.5.description'),
        pressReleaseDoc: t('common:page_press.release.5.pressReleaseDoc'),
        images: [t('common:page_press.release.5.cover_pic')],
        downloads: [
          {
            title: 'Download Dossier',
            url: t('common:page_press.release.5.zip'),
          },
        ],
      },
      {
        date: '17/03/2023',
        title: t('common:page_press.release.4.title'),
        subtitle: t('common:page_press.release.4.description'),
        pressReleaseDoc: t('common:page_press.release.4.pressReleaseDoc'),
        images: [t('common:page_press.release.4.cover_pic')],
        downloads: [
          {
            title: 'Download Dossier',
            url: t('common:page_press.release.4.zip'),
          },
        ],
      },
      {
        date: '06/09/2022',
        title: t('common:page_press.release.3.title'),
        subtitle: t('common:page_press.release.3.description'),
        pressReleaseDoc: t('common:page_press.release.3.pressReleaseDoc'),
        images: [t('common:page_press.release.3.cover_pic')],
        downloads: [
          {
            title: 'Download Dossier',
            url: t('common:page_press.release.3.zip'),
          },
        ],
      },
      {
        date: '07/03/2022',
        title: t('common:page_press.release.1.title'),
        subtitle: t('common:page_press.release.1.description'),
        pressReleaseDoc:
          'https://storage.googleapis.com/bevmaq-public/Press-Release_Online-platform-BEVMAQ-grows-and-expands_03072022.pdf',
        images: ['/press_img1.png'],
        downloads: [
          {
            title: 'Download Dossier',
            url: 'https://storage.googleapis.com/bevmaq-public/Press-Dossier_BEVMAQ-grows-and-expands_03072022.zip',
          },
        ],
      },
      {
        date: '24/11/2021',
        title:
          'BEVMAQ: The Platform Group launches online platform for beverage machines',
        subtitle:
          'The Wiesbaden-based The Platform Group is expanding its platform business by founding BEVMAQ GmbH. The newly founded company, headquartered in Quakenbrück, Germany, specializes in the global trading of used machinery and equipment for the beverage industry.',
        pressReleaseDoc:
          'https://storage.googleapis.com/bevmaq-public/Press-Release_BEVMAQ_24112021.pdf',
        images: ['/bevmaq_team.jpg'],
        downloads: [
          {
            title: 'Download Dossier',
            url: 'https://storage.googleapis.com/bevmaq-public/Press-Release_BEVMAQ-launch_11242021.zip',
          },
        ],
      },
    ],
    [t]
  );
  const [news, setNews] = useState(pressReleasesDB);
  const { locale } = useRouter();
  function formatDate(europeanDate: string, locale: string) {
    const usaFormat = new Date(
      europeanDate.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$2/$1/$3')
    );
    return locale === 'en-US'
      ? usaFormat.toLocaleDateString(locale, {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        })
      : europeanDate;
  }

  useEffect(() => {
    const receiveMessage = (event: MessageEvent<any>) => {
      console.log('event', event);
      const { pressRelease } = event.data;
      if (!isEmpty(pressRelease)) {
        setNews([pressRelease, ...pressReleasesDB]);
      }
    };

    window.addEventListener('message', receiveMessage);

    return () => {
      window.removeEventListener('message', receiveMessage);
    };
  }, [pressReleasesDB]);

  return (
    <div className='w-full space-y-12'>
      <h3 className='text-start text-2xl font-semibold text-black'>
        {t('common:Press Releases')}
      </h3>
      {news.map((pressRelease) => (
        <div
          className='grid gap-4 md:grid-cols-2'
          key={pressRelease.title + pressRelease.subtitle}
        >
          <div className='flex flex-col items-center space-y-3 pb-12 md:items-start '>
            <div className=''>
              <h5 className='text-md text-gray2-500'>
                {formatDate(pressRelease.date, locale ?? 'en-US')}
              </h5>
              <h3 className='mb-8 mt-2 text-center text-lg font-medium text-black  md:text-left'>
                {pressRelease.title}
              </h3>
              <h3
                className=' text-center md:text-left'
                dangerouslySetInnerHTML={{ __html: pressRelease.subtitle }}
              />
            </div>
            <a
              href={pressRelease.pressReleaseDoc}
              target='_blank'
              rel='noreferrer'
            >
              <button className='rounded bg-orange-400 px-8 py-4 font-bold text-white hover:bg-orange-500'>
                {t('common:See Press Release')}
              </button>
            </a>
            {pressRelease.downloads.map((dowload) => (
              <Download
                link={dowload.url}
                title={dowload.title}
                subtitle={t('common:Click here to download')}
                key={dowload.url}
                size='sm'
              />
            ))}
          </div>
          <div className='min-h-[20em]'>
            <div className='relative h-full w-full '>
              <Image
                src={pressRelease.images[0]}
                alt='Press release image'
                fill
                className='object-contain'
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

function PressRelease({
  accountManager,
}: {
  accountManager: AccountManagerType;
}) {
  const { t } = useTranslation();
  const title = t('common:Press');
  const subtitle = t('common:press.subtitle');
  const components = [
    <div className='flex flex-col items-center bg-white' key='press'>
      <div className='grid max-w-7xl grid-cols-1 gap-4 bg-white md:grid-cols-6 '>
        <div className='mb-auto flex flex-col justify-center space-y-4 pb-12 md:col-span-3 lg:col-span-4'>
          <h4 className='text-start text-2xl font-semibold text-black'>
            {t('common:page_press.about.title')}
          </h4>
          <h3>
            <Trans
              i18nKey='common:page_press.about.subtitle'
              components={{
                link: <a className='link' href={'https://bevmaq.com'} />,
              }}
            />
          </h3>

          <h3>{t('common:page_press.about.subtitle2')}</h3>
        </div>
        <div className='flex flex-col items-center justify-center space-y-4 pb-2 md:col-span-3 lg:col-span-2'>
          <h4 className='text-center text-2xl font-semibold text-black'>
            {t('common:page_press.about.press_contact')}
          </h4>
          <AccountManager
            containerClasses='p-0 m-0'
            companyPosition='Managing Director – Marketing'
            name='Benedikt Ruf'
            email='b.ruf@bevmaq.com'
            phone='+49 173 273 1973'
            profileImage='/benedikt2.png'
            imgClass={'h-[13em] w-[14em]'}
            accountManager={accountManager}
          />
        </div>
      </div>
      <PressReleases />
      <div className='w-full space-y-12'>
        <h3 className='text-start text-2xl font-semibold text-black'>
          {t('common:page_press.Media_Download')}
        </h3>
        <Download
          link='https://storage.googleapis.com/bevmaq-public/BEVMAQ_Logo-horizontal.jpg'
          title='BEVMAQ - Logo PNG'
          size='sm'
        />
        <Download link='/logo.jpg' title='BEVMAQ - Logo JPG' size='sm' />
        <Download
          link='https://storage.googleapis.com/bevmaq-public/IMG_BM_Gruenderteam.jpg.jpg'
          title='BEVMAQ - Founders'
          size='sm'
        />
      </div>
    </div>,
  ];

  return (
    <StaticPageTemplate
      title={title}
      subtitle={subtitle}
      components={components}
    />
  );
}

 const _getStaticProps: GetStaticProps = async () => {
  return {
    props: {
      hasContainer: false,
    },
  };
};

export default PressRelease;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/press',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  